import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import {setGetViewTournamentStat} from '../../store/thunk/setGetViewTournamentStat';
import {setGetViewTournament} from '../../store/thunk/setGetViewTournament';
import Dialog from '@material-ui/core/Dialog';
import { setPostIssueTournament } from '../../store/thunk/setPostIssueTournament';
import { setPostCreateUser } from '../../store/thunk/setPostCreateUser';
import {setPostUpdatePoints} from '../../store/thunk/setPostUpdatePoints';

const StatTournament = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const {id} = router.match.params;
    const [openModal, setOpenModal] = React.useState(false);
    const [createUserOpenModal, setCreateUserOpenModal] = React.useState(false);
    const [updatePoints, setUpdatePoints] = React.useState(false);
    const [userId, setUserId] = React.useState(0);
    const [points, setPoints] = React.useState(0);

    React.useEffect(() => {
        dispatch(setGetViewTournamentStat({
            id_tournament: id
        }))
        dispatch(setGetViewTournament({
            id_tournament: id
        }))
    }, [id])
    const tournament = useSelector(state => state.tournament.list_stat);
    const info = useSelector(state => state.tournament.view);

    const getDates = (val) => {
        const date = new Date(+val);

        const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const month = (date.getMonth()+1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;

    }

    return (
        <div style={{padding: 20, paddingTop: 0}}>
            <Title label="Статистика турнира" />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8,
                display: 'flex',
                justifyContent: 'flex-end'
            }}>
                <span style={{
                    padding: '10px',
                    background: info.status ? 'rgb(255, 195, 36)' : '#eee',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: 'rgb(20, 27, 51)',
                }}
                    onClick={() => {
                        if (info.status) {
                            setOpenModal(true)
                        }
                        
                    }}
                >Выдать призы</span>
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8,
                marginTop: 12
            }}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <h3 style={{margin: 0, padding: 0, color: '#fff', marginBottom: 12}}>Информация о турнире</h3>
                    <div>
                        <span 
                            onClick={() => setCreateUserOpenModal(true)}
                            style={{
                                padding: '10px',
                                background: info.status ? 'rgb(255, 195, 36)' : '#eee',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                color: 'rgb(20, 27, 51)',
                            }}
                        >Добавить игрока</span>
                    </div>
                </div>
                
                <div style={{display: 'flex', flexDirection: 'column', color: '#fff', marginBottom: 12}}>
                    <span>Количество победителей: {info.count_winners}</span>
                    <span>Окончание турнира: {getDates(isNaN(+info.end) ? 0 : info.end)}</span>
                    <span>Призы разданы: {info.status ? 'Не выданы' : 'Выданы'}</span>
                </div>
                

                <h3 style={{margin: 0, padding: 0, color: '#fff', marginBottom: 12}}>Текущие результаты</h3>
                <div>
                    <div style={{display: 'flex'}}>
                        <span style={{width: 250, color: '#fff'}}>Логин</span>
                        <span style={{color: '#fff'}}>Очки</span>
                    </div>
                    {
                        tournament.map((item) => (
                            <div style={{color: '#fff', display: 'flex', height: 50}}>
                                <span style={{width: 250}}>{item.login}</span>
                                <span style={{width: 100}}>{item.points - 10}</span>
                                <div>
                                    <span 
                                        onClick={() => {
                                            setUpdatePoints(true);
                                            setUserId(+item.id_profile)
                                        }}
                                        style={{
                                            padding: '10px',
                                            background: info.status ? 'rgb(255, 195, 36)' : '#eee',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            color: 'rgb(20, 27, 51)',
                                        }}
                                    >Добавить очки</span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div style={{padding: 20}}>
                    <h3 style={{margin: 0, padding: 0, color: '#2f2f2f'}}>
                        Закончить трунир и выдать призы?
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', columnGap: 5, marginTop: 12}}>
                        <span 
                            style={{padding: '10px', width: '50%', background: '#ffce01', borderRadius: 8, cursor: 'pointer'}}
                            onClick={() => {
                                dispatch(setPostIssueTournament({
                                    id_tournament: id
                                }))
                                setOpenModal(false);
                            }}
                        >Да</span>
                        <span 
                            onClick={() => setOpenModal(false)}
                            style={{padding: '10px',  width: '50%', border: '1px solid #adadad', borderRadius: 8, cursor: 'pointer'}}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => {
                setCreateUserOpenModal(false)
                setUserId(0)
            }} open={createUserOpenModal}>
                <div style={{padding: 20, width: 300}}>
                    <div>
                        <h3 style={{
                            margin: 0, 
                            padding: 0, 
                            color: '#2f2f2f',
                            display: 'flex', 
                            justifyContent: 'center'
                        }}>
                            Введите ID игрока
                        </h3>
                    </div>
                    
                    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', textAlign: 'center', columnGap: 5, marginTop: 12}}>
                        <div style={{width: '100%', marginBottom: 12}}>
                            <input 
                                type="text"
                                style={{
                                    border: '1px solid #eee',
                                    padding: 10,
                                    outline: 'none',
                                    width: 'calc(100% - 20px)'
                                }}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setUserId(+v.target.value)   
                                    }
                                }}
                                value={userId}
                            />
                        </div>
                        <span 
                            style={{padding: '10px', width: '50%', background: '#ffce01', borderRadius: 8, cursor: 'pointer'}}
                            onClick={() => {
                                dispatch(setPostCreateUser({
                                    id_tournament: id,
                                    userId
                                }))
                                setCreateUserOpenModal(false);
                                setUserId(0)
                            }}
                        >Добавить</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => {
                setUpdatePoints(false);
                setUserId(0);
                setPoints(0)
            }} open={updatePoints}>
                <div style={{padding: 20, width: 300}}>
                    <div>
                        <h3 style={{
                            margin: 0, 
                            padding: 0, 
                            color: '#2f2f2f',
                            display: 'flex', 
                            justifyContent: 'center'
                        }}>
                            Введите  кол-во очков
                        </h3>
                    </div>
                    
                    <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', textAlign: 'center', columnGap: 5, marginTop: 12}}>
                        <div style={{width: '100%', marginBottom: 12}}>
                            <input 
                                type="text"
                                style={{
                                    border: '1px solid #eee',
                                    padding: 10,
                                    outline: 'none',
                                    width: 'calc(100% - 20px)'
                                }}
                                onChange={(v) => {
                                    if (!isNaN(+v.target.value)) {
                                        setPoints(+v.target.value)   
                                    }
                                }}
                                value={points}
                            />
                        </div>
                        <span 
                            style={{padding: '10px', width: '50%', background: '#ffce01', borderRadius: 8, cursor: 'pointer'}}
                            onClick={() => {
                                dispatch(setPostUpdatePoints({
                                    id_tournament: id,
                                    userId,
                                    points
                                }))
                                setUpdatePoints(false);
                                setUserId(0);
                                setPoints(0)
                            }}
                        >Обновить</span>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default StatTournament;